/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../utils/logger';

import axios from 'axios';
import config from '../config/config';

const baseUrl = config.apiBaseUrl;
export const ImageBaseUrl = config.imageBaseUrl;

export const defaultApi = axios.create({
  baseURL: baseUrl,
  withCredentials: true, // Ensuring cookies are handled even for "default" calls
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Response: handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      logger.warn('401 Unauthorized detected. Preventing loop if on login or other public pages.');
      // Clear auth
      localStorage.removeItem('user');

      const publicPaths = [
        '/login',
        '/signup',
        '/signup-form',
        '/forgot-password',
        '/reset-password',
      ];
      const normalizedPath = window.location.pathname.replace(/\/$/, '');
      const isPublicPage =
        publicPaths.includes(normalizedPath) || normalizedPath.startsWith('/page/');
      const requestUrl = error?.config?.url || '';
      const isPublicApi = requestUrl.includes('/cms-links') || /\/page\/[^/]+$/.test(requestUrl);

      if (!isPublicPage && !isPublicApi) {
        const currentPath = window.location.pathname + window.location.search;
        window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  }
);
export const saveNodes = async (data) => {
  try {
    const response = await api.post('/nodes', data);
    return response.data;
  } catch (error) {
    logger.error('Error saving nodes:', error);
    throw error;
  }
};

export const editorialPublishAPI = async (payload) => {
  try {
    const response = await api.post('/editorial-publish', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Editorial Publish:', error);
    throw error;
  }
};

export const contentChangeRequest = async (payload) => {
  try {
    const response = await api.post('/content-change-request', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Editorial Publish:', error);
    throw error;
  }
};

export const contentapproveProcess = async (payload) => {
  try {
    const response = await api.post('/process/approve', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Approve Process:', error);
    throw error;
  }
};

export const contentRequestChange = async (payload) => {
  try {
    const response = await api.post('/process/request-change', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Request Change:', error);
    throw error;
  }
};

export const cancelPublishingAPI = async (payload) => {
  try {
    const response = await api.post('/process/cancel-publishing', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Cancel Publishing:', error);
    throw error;
  }
};

export const contentrequestChange = async (payload) => {
  try {
    const response = await api.post('/process/request-change', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Request Change:', error);
    throw error;
  }
};

export const getNextPageGroupId = async (Page_Title = null) => {
  try {
    const response = await api.get('/getNext-PageGroupId', {
      params: {
        Page_Title,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const getNodes = async (
  level = null,
  user_id = null,
  Process_id = null,
  currentParentId = null,
  language_id = null,
  NodesStatus = null
) => {
  try {
    const response = await api.get('/nodes', {
      params: {
        level,
        user_id,
        Process_id,
        currentParentId,
        language_id,
        NodesStatus,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const getallpublishObject_Tolinkexistingmodel = async (
  user_id = null,
  Process_id = null,
  processDefaultlanguage_id = null
) => {
  try {
    const response = await api.get('/getallpublishObject_Tolinkexistingmodel', {
      params: {
        user_id,
        Process_id,
        processDefaultlanguage_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const getexistingrole = async (level = null, user_id = null, Process_id = null) => {
  try {
    const response = await api.get('/getexistingrole', {
      params: {
        level,
        user_id,
        Process_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const checkRecord = async (level = null, Process_id = null) => {
  try {
    const response = await api.get('/check-record', {
      params: {
        level,
        Process_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const checkRecordWithGetLinkDraftData = async (
  level = null,
  user_id = null,
  Process_id = null,
  LinkLevel = null
) => {
  try {
    const response = await api.get('/check-record-withgetlinkdraft-data', {
      params: {
        level,
        user_id,
        Process_id,
        LinkLevel,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const checkRecordWithGetLinkPublishData = async (
  level = null,
  user_id = null,
  Process_id = null,
  LinkLevel = null
) => {
  try {
    const response = await api.get('/check-record-withgetlinkPublish-data', {
      params: {
        level,
        user_id,
        Process_id,
        LinkLevel,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const checkPublishRecord = async (level = null, Process_id = null) => {
  try {
    const response = await api.get('/checkPublishRecord', {
      params: {
        level,
        Process_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const checkParentPublishRecords = async (node_id = null, Process_id = null) => {
  try {
    const response = await api.get('/checkParentPublishRecords', {
      params: {
        node_id,
        Process_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const GetPublishedDate = async (Process_id = null, status = null, PageGroupId = null) => {
  try {
    const response = await api.get('/GetPublishedDate', {
      params: {
        Process_id,
        status,
        PageGroupId,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const getUserNodes = async (user_id = null) => {
  try {
    const response = await api.get('/getUserNodes', {
      params: {
        user_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const getPublishedNodes = async (
  level = null,
  user_id = null,
  Process_id = null,
  currentParentId = null,
  language_id = null
) => {
  try {
    const response = await api.get('/Publishnodes', {
      params: {
        level,
        user_id,
        Process_id,
        currentParentId,
        language_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const filter_draft = async (ParentPageGroupId = null) => {
  try {
    const response = await api.get('/nodes/filter-draft', {
      params: { ParentPageGroupId },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const getdataByNodeId = async (node_id = null, status = null) => {
  try {
    const response = await api.get('/nodes/getdataByNodeId', {
      params: { node_id, status },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const Login = async (email, password) => {
  try {
    const response = await api.post('/login', { email, password });
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await api.post('/forgot-password', { email });
    return response.data;
  } catch (error) {
    logger.error('Error sending forgot password link:', error);
    throw error.response?.data || error;
  }
};

export const resetPassword = async (token, password, password_confirmation) => {
  try {
    const response = await api.post('/reset-password', {
      token,
      password,
      password_confirmation,
    });
    return response.data;
  } catch (error) {
    logger.error('Error resetting password:', error);
    throw error.response?.data || error;
  }
};

export const verifyResetToken = async (token) => {
  try {
    const response = await api.get('/verify-reset-token', {
      params: { token },
    });
    return response.data;
  } catch (error) {
    logger.error('Error verifying reset token:', error);
    throw error.response?.data || error;
  }
};

export const CurrentUser = async () => {
  try {
    const response = await api.get('/user');
    return response.data;
  } catch (error) {
    logger.error('Error fetching nodes:', error);
    throw error;
  }
};

export const refreshToken = async () => {
  try {
    const response = await api.post('/refresh-token');
    return response.data;
  } catch (error) {
    logger.error('Error refreshing token:', error);
    throw error;
  }
};

export const deactivateUser = async () => {
  try {
    const response = await api.post(
      '/deactivate-user',
      {}, // Empty body (if your API requires a payload, add it here)
      {
        headers: {
          'Content-Type': 'application/json', // Ensure JSON format
        },
      }
    );
    return response.data;
  } catch (error) {
    logger.error('Error deactivating user:', error.response?.data || error.message);
    throw error;
  }
};

export const updateprofile = async (profileData) => {
  try {
    const response = await api.post(
      '/update-profile',
      profileData, // Pass the updated profile data here
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    logger.error('Error updating profile:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteExistingRole = async (
  Process_id = null,
  PageGroupId = null,
  parentId = null,
  link = null
) => {
  try {
    const response = await api.post('/delete-role-link', {
      Process_id,
      PageGroupId,
      parentId,
      link,
    });
    return response.data;
  } catch (error) {
    logger.error('Error deleting existing role:', error);
    throw error;
  }
};

export const removeProfileImgage = async () => {
  try {
    const response = await api.delete('/remove-profile-image', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    logger.error('Error updating profile:', error.response?.data || error.message);
    throw error;
  }
};

export const saveProcessTitle = async (
  title,
  defaultLanguage,
  supportedLanguages,
  translations
) => {
  try {
    const response = await api.post('/process-titles', {
      process_title: title,
      defaultLanguage,
      supportedLanguages,
      translations,
    });
    return response.data;
  } catch (error) {
    logger.error('Error saving process title:', error);
    throw error;
  }
};

export const ProcessAssign = async (user_id, process_id, assigned_users) => {
  try {
    const response = await api.post('/process-Assign', { user_id, process_id, assigned_users });
    return response.data;
  } catch (error) {
    logger.error('Error saving process title:', error);
    throw error;
  }
};

export const getProcessTitles = async (user_id = null) => {
  try {
    const response = await api.get('/process-titles', {
      params: {
        user_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const getProcessAssignUsers = async (process_id = null) => {
  try {
    const response = await api.get('/get-process-assign-users', {
      params: {
        // user_id,
        process_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const checkEmail = async (email = null) => {
  try {
    const response = await api.get('/check-email', {
      params: {
        email,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const saveAssingUserData = async (newUserObject = null) => {
  try {
    const response = await api.post('/save-Assign-User-Data', newUserObject);
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const updateAssignedUserData = async (newUserObject = null) => {
  try {
    const response = await api.post('/update-assigned-user', newUserObject);
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const addFavProcess = async (process_id, type, PageGroupId, currentParentId) => {
  try {
    const response = await api.post('/add-fav-process', {
      process_id,
      type,
      PageGroupId,
      currentParentId,
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const removeFavProcess = async (process_id, PageGroupId) => {
  try {
    const response = await api.post('/remove-fav-process', { process_id, PageGroupId });
    return response.data;
  } catch (error) {
    logger.error('Error removing favorite process:', error);
    throw error;
  }
};

export const checkFavProcess = async (process_id, PageGroupId) => {
  try {
    const response = await api.get('/check-fav-process', {
      params: {
        process_id,
        PageGroupId,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};
export const getFavProcessesByUser = async () => {
  try {
    const response = await api.get('/get-fav-processes', {
      // params: {
      //     user_id
      // }
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const getProcessTitleById = async (id) => {
  try {
    const response = await api.get('/get-process-ById', {
      params: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const updateProcess = async (processId, processdata) => {
  try {
    const response = await api.post(
      `/update-process-ById?id=${processId}`, // Pass ID as a query parameter
      processdata,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    logger.error('Error updating process:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteProcess = async (processId) => {
  try {
    const response = await api.delete(`/delete-process-ById?id=${processId}`);
    return response.data;
  } catch (error) {
    logger.error('Error deleting process:', error.response?.data || error.message);
    throw error;
  }
};

export const removeProcessImage = async (ProcessId) => {
  try {
    const response = await api.delete(`/remove-process-image?id=${ProcessId}`);

    return response;
  } catch (error) {
    logger.error('Error updating profile:', error.response?.data || error.message);
    throw error;
  }
};

export const getvideo = async (id) => {
  try {
    const response = await api.get('/get-video');
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const signup = async (newUserObject = null) => {
  try {
    const response = await api.post('/signup', newUserObject);
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const submitSignupForm = async (newUserObject = null) => {
  try {
    const response = await api.post('/submitSignupForm', newUserObject);
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const fetchCmsPage = async (slug, lang = 'EN') => {
  try {
    const response = await api.get(`/page/${slug}`, {
      params: { lang },
    });
    return response.data;
  } catch (error) {
    logger.error(`Error fetching CMS page ${slug}:`, error);
    throw error;
  }
};

export const fetchCmsLinks = async (lang = 'EN') => {
  try {
    const response = await api.get('/cms-links', {
      params: { lang },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching CMS links:', error);
    throw error;
  }
};

export const versionlist = async (processId, level, LoginUserId, status) => {
  try {
    const response = await api.get('/version/list', {
      params: {
        process_id: processId,
        level: level,
        LoginUserId: LoginUserId,
        status: status,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const ReplaceVersion = async (level, processId, version) => {
  try {
    const response = await api.post('/replace-version', {
      process_id: processId,
      level: level,
      version: version,
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const getVersionViewData = async (
  processId,
  level,
  version,
  pageTitle,
  currentParentId,
  language_id = null
) => {
  try {
    const response = await api.get(`/process/view/${processId}/${level}/${version}/${pageTitle}`, {
      params: {
        currentParentId: currentParentId,
        language_id: language_id,
      },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching version view data:', error);
    throw error;
  }
};

// Save Process Info (contact + revision)
export const saveProcessInfo = async (data) => {
  try {
    const response = await api.post('/process-info', data);
    return response.data;
  } catch (error) {
    logger.error('Error saving process info:', error);
    throw error;
  }
};

export const googleOAuth = async (tokenId) => {
  try {
    const response = await api.post('/oauth/google', { tokenId });
    return response.data; // Return JSON directly
  } catch (error) {
    logger.error('Google OAuth API Error:', error);
    throw error.response ? error.response.data : error;
  }
};

// ✅ Microsoft OAuth API Call
export const microsoftOAuth = async (access_token) => {
  try {
    const response = await api.post('/oauth/microsoft', { access_token });
    return response.data;
  } catch (error) {
    logger.error('Microsoft OAuth API Error:', error);
    throw error.response ? error.response.data : error;
  }
};

export const getLanguages = async () => {
  try {
    const response = await api.get('/languages');
    return response;
  } catch (error) {
    logger.error('Error fetching process titles:', error);
    throw error;
  }
};

export const getPublicTranslations = async (lang) => {
  try {
    const response = await defaultApi.get(`/translations/${lang}`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching public translations:', error);
    throw error;
  }
};

export const duplicateNode = async (payload) => {
  try {
    const response = await api.post('/nodes/duplicate', payload);
    return response.data;
  } catch (error) {
    logger.error('Error duplicating node:', error);
    throw error;
  }
};

export const moveNode = async (payload) => {
  try {
    const response = await api.post('/nodes/move', payload);
    return response.data;
  } catch (error) {
    logger.error('Error moving node:', error);
    throw error;
  }
};

export const publishMovedNode = async (payload) => {
  try {
    const response = await api.post('/nodes/publish-moved', payload);
    return response.data;
  } catch (error) {
    logger.error('Error publishing moved node:', error);
    throw error;
  }
};

export const contectCancelPublishing = async (payload) => {
  try {
    const response = await api.post('/process/cancel-publishing', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Cancel Publishing:', error);
    throw error;
  }
};

export const contectApprovalStatus = async (payload) => {
  try {
    const response = await api.post('/approval/status', payload);
    return response;
  } catch (error) {
    logger.error('Error in Cancel Publishing:', error);
    throw error;
  }
};

export const contentreschedulePublishing = async (payload) => {
  try {
    const response = await api.post('/process/reschedule-publishing', payload);
    return response.data;
  } catch (error) {
    logger.error('Error in Reschedule Publishing:', error);
    throw error;
  }
};

export const contectCronPublish = async () => {
  try {
    const response = await api.get('/process/pending-publish');
    return response.data;
  } catch (error) {
    logger.error('Error in Cron Publish:', error);
    throw error;
  }
};

export const getManagedProcesses = async (data) => {
  try {
    const response = await api.post('/nodes/getManagedProcesses', data);
    return response.data;
  } catch (error) {
    logger.error('Error fetching managed processes:', error);
    throw error;
  }
};

export const createRole = async (data) => {
  try {
    const response = await api.post('/roles/create', data);
    return response.data;
  } catch (error) {
    logger.error('Error creating role:', error);
    throw error;
  }
};

export const enableTwoFactor = async () => {
  try {
    const response = await api.post('/2fa/enable');
    return response.data;
  } catch (error) {
    logger.error('Error enabling 2FA:', error);
    throw error;
  }
};

export const verifyTwoFactor = async (payload) => {
  try {
    const response = await api.post('/2fa/verify', payload);
    return response.data;
  } catch (error) {
    logger.error('Error verifying 2FA:', error);
    throw error;
  }
};

export const disableTwoFactor = async () => {
  try {
    const response = await api.post('/2fa/disable');
    return response.data;
  } catch (error) {
    logger.error('Error disabling 2FA:', error);
    throw error;
  }
};

export const getRecoveryCodes = async () => {
  try {
    const response = await api.get('/2fa/recovery-codes');
    return response.data;
  } catch (error) {
    logger.error('Error fetching 2FA recovery codes:', error);
    throw error;
  }
};

export const loginVerifyTwoFactor = async (payload) => {
  try {
    const response = await api.post('/2fa/login-verify', payload);
    return response.data;
  } catch (error) {
    logger.error('Error verifying login 2FA:', error);
    throw error;
  }
};

export const logCookieConsentAPI = async (categories) => {
  try {
    const response = await defaultApi.post('/log-cookie-consent', { categories });
    return response.data;
  } catch (error) {
    logger.error('Error logging cookie consent:', error);
    throw error;
  }
};

export const getEnergyStats = async (processId, version = null, level = null) => {
  try {
    const response = await api.get(`/viewer/processes/${processId}/energy-stats`, {
      params: { version, level },
    });
    return response.data;
  } catch (error) {
    logger.error('Error fetching energy stats:', error);
    return null;
  }
};

export const getUserRating = async (processId, activityId, version = null) => {
  try {
    const response = await api.get(
      `/viewer/processes/${processId}/activities/${activityId}/my-rating`,
      {
        params: { version },
      }
    );
    return response.data;
  } catch (error) {
    logger.error('Error fetching user rating:', error);
    return null;
  }
};

export const saveUserRating = async (
  processId,
  activityId,
  vote,
  reason = null,
  version = null
) => {
  try {
    const response = await api.put(
      `/viewer/processes/${processId}/activities/${activityId}/my-rating`,
      {
        vote,
        reason,
        version,
      }
    );
    return response.data;
  } catch (error) {
    logger.error('Error saving user rating:', error);
    throw error;
  }
};

export const deleteUserRating = async (processId, activityId, version = null) => {
  try {
    const response = await api.delete(
      `/viewer/processes/${processId}/activities/${activityId}/my-rating`,
      {
        params: { version },
      }
    );
    return response.data;
  } catch (error) {
    logger.error('Error deleting user rating:', error);
    throw error;
  }
};

const apiExports = {
  createRole,
  saveNodes,
  getallpublishObject_Tolinkexistingmodel,
  getexistingrole,
  getNodes,
  checkPublishRecord,
  GetPublishedDate,
  checkRecord,
  Login,
  saveProcessTitle,
  defaultApi,
  filter_draft,
  getPublishedNodes,
  getdataByNodeId,
  duplicateNode,
  moveNode,
  getManagedProcesses,
  enableTwoFactor,
  verifyTwoFactor,
  disableTwoFactor,
  getRecoveryCodes,
  loginVerifyTwoFactor,
  logCookieConsentAPI,
  getEnergyStats,
  getUserRating,
  saveUserRating,
  deleteUserRating,
};

export default apiExports;
